export default __webpack_public_path__ + "static/media/matas.59f78bfd.png";